import { useRef } from "react";

export const useCursorPosition = () => {
  const positionRef = useRef(null);

  const saveCursorPosition = (element) => {
    if (element && document.activeElement === element) {
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        positionRef.current = range.startOffset;
      }
    }
  };

  const restoreCursorPosition = (element) => {
    if (
      element &&
      document.activeElement === element &&
      positionRef.current !== null
    ) {
      const selection = window.getSelection();
      const range = document.createRange();
      const textNode = element.firstChild;

      if (selection && textNode?.nodeType === Node.TEXT_NODE) {
        const position = Math.min(
          positionRef.current,
          textNode.textContent?.length || 0,
        );
        try {
          range.setStart(textNode, position);
          range.setEnd(textNode, position);
          selection.removeAllRanges();
          selection.addRange(range);
        } catch (e) {
          console.error("Error restoring cursor position:", e);
        }
      }
    }
  };

  return {
    saveCursorPosition,
    restoreCursorPosition,
    cursorPositionRef: positionRef,
  };
};
